import React, { useState, useEffect } from 'react'

import { classnames } from '@cgtrader/triangle-ui/dist/src/ssr-index'

import AmazonLogo from 'Pods/Shared/Icons/brands/AmazonLogo'
import DisneyLogo from 'Pods/Shared/Icons/brands/DisneyLogo'
import GoogleLogo from 'Pods/Shared/Icons/brands/GoogleLogo'
import MetaLogo from 'Pods/Shared/Icons/brands/MetaLogo'
import MicrosoftLogo from 'Pods/Shared/Icons/brands/MicrosoftLogo'
import NetflixLogo from 'Pods/Shared/Icons/brands/NetflixLogo'
import NvidiaLogo from 'Pods/Shared/Icons/brands/NvidiaLogo'
import RobloxLogo from 'Pods/Shared/Icons/brands/RobloxLogo'
import SamsungLogo from 'Pods/Shared/Icons/brands/SamsungLogo'
import SonyLogo from 'Pods/Shared/Icons/brands/SonyLogo'
import WetaFXLogo from 'Pods/Shared/Icons/brands/WetaFXLogo'

function TrustedBrands() {
  const [isAnimated, setIsAnimated] = useState(false)

  useEffect(() => {
    setIsAnimated(true)
  }, [])

  const logos = [
    { Component: NvidiaLogo, height: '48px', width: '100px' },
    { Component: MetaLogo, height: '48px', width: '100px' },
    { Component: SonyLogo, height: '48px', width: '100px' },
    { Component: GoogleLogo, height: '48px', width: '100px' },
    { Component: AmazonLogo, height: '48px', width: '100px' },
    { Component: NetflixLogo, height: '48px', width: '100px' },
    { Component: RobloxLogo, height: '48px', width: '100px' },
    { Component: MicrosoftLogo, height: '48px', width: '100px' },
    { Component: DisneyLogo, height: '48px', width: '100px' },
    { Component: SamsungLogo, height: '48px', width: '100px' },
    { Component: WetaFXLogo, height: '48px', width: '100px' },
  ]

  const renderLogos = () => {
    return logos.map(({ Component, width, height }, index) => (
      <div key={index} className="trusted-brands__logo">
        <Component width={width} height={height} />
      </div>
    ))
  }

  return (
    <div className="trusted-brands">
      <div className="trusted-brands__track">
        <div className={classnames(
          'trusted-brands__content',
          isAnimated && 'trusted-brands__animated'
        )}>
          {renderLogos()}
        </div>
        <div className={classnames(
            'trusted-brands__content',
            isAnimated && 'trusted-brands__animated'
          )}
        >
          {renderLogos()}
        </div>
      </div>
    </div>
  )
}

export default TrustedBrands
